// Fields the save button gates on. Unchanged from the pre-redesign panel.
export const REQUIRED_FIELDS = [
    'location_name',
    'business_address',
    'business_zip',
    'business_city',
    'business_state',
    'location_type',
    'location_info',
];

// Human labels for REQUIRED_FIELDS, so a blocked save can name what is actually missing rather
// than leaving the user to hunt for it.
export const REQUIRED_FIELD_LABELS = {
    location_name: 'Location Name',
    business_address: 'Address',
    business_zip: 'Zip Code',
    business_city: 'City',
    business_state: 'State',
    location_type: 'Location type',
    location_info: 'Location details',
};

// Index order is load-bearing: `hours_open[idx]` and `day_num` both key off it, and it matches
// `hoursOpenArray` in constants/hoursConstants. Sunday is 0.
export const DAYS = [
    { value: 'sunday', display: 'Sunday' },
    { value: 'monday', display: 'Monday' },
    { value: 'tuesday', display: 'Tuesday' },
    { value: 'wednesday', display: 'Wednesday' },
    { value: 'thursday', display: 'Thursday' },
    { value: 'friday', display: 'Friday' },
    { value: 'saturday', display: 'Saturday' },
];

// Two columns in the design, and the client column names double as the location field names.
export const HOLIDAYS = [
    [
        { value: 'xmas', display: 'Christmas' },
        { value: 'xmas_eve', display: 'Christmas Eve' },
        { value: 'new_years_eve', display: 'New Years Eve' },
        { value: 'new_years_day', display: 'New Years Day' },
    ],
    [
        { value: 'labor_day', display: 'Labor Day' },
        { value: 'memorial_day', display: 'Memorial Day' },
        { value: 'thanksgiving', display: 'Thanksgiving' },
        { value: 'july_fourth', display: 'Independence Day' },
    ],
];

export const HOLIDAY_FIELDS = HOLIDAYS.flat().map((h) => h.value);

export const LOCATION_TYPES = [
    { value: 'Business', label: 'Business/Showroom' },
    { value: 'Residence', label: 'Residence' },
];

// `location_info` options depend on `location_type` — the old panel rendered a different Select
// for each, and switching type leaves the stored value until it is re-picked.
export const LOCATION_INFO_OPTIONS = {
    Business: [
        { value: 'inStore', label: 'In Store Pick Up' },
        { value: 'rollUpDoor', label: 'Warehouse/Roll Up Door' },
        { value: 'dock', label: 'Dock Pick Up' },
    ],
    Residence: [
        { value: 'whiteGlove', label: 'In Home Pick Up' },
        { value: 'curbside', label: 'Curbside/Garage Pick Up' },
    ],
};

export const DEFAULT_HOURS_OPTION = 'default';

export const HOURS_TOOLTIP =
    'These are the hours we will use when scheduling pickups. Set them per location, or leave a location on your default hours.';

// What the Figma "Operational · Stores" frame shows, versus what this panel actually does.
//
// The design draws a single state — Default Hours with no location selected — so it omits the
// Remove Location button, the whole location-details form (name, code, address, contact, pickup
// preferences, QBO class), the first-location registration flow, and the validation messages.
// None of that was dropped: the design is treated as guidance for the parts it covers, and the
// rest is restyled to match. There is nothing here the design supports that the data does not.
export const DESIGN_COVERS = ['location-selector', 'add-location', 'hours-grid', 'holiday-toggles', 'save-bar'];
